import { z } from "zod";
import { appointmentStatusSchema } from "./appointment.js";
import { specialtySchema } from "./clinician.js";
/**
 * Request contracts for the booking loop. Imported by both the handler, which
 * validates against them, and the web app, which builds requests from them -
 * so a field cannot be renamed on one side alone.
 */
export const createAppointmentSchema = z.object({
    clinician_id: z.string().min(1).max(128),
    /** Must match an open slot on that specialist exactly. */
    starts_at: z.string().datetime(),
    reason: z
        .string()
        .trim()
        .min(10, "Describe what you would like a second opinion about.")
        .max(2000),
    /**
     * Set only when a coordinator books on behalf of a patient who phoned in.
     * Ignored when a patient books for themselves - a patient cannot book as
     * somebody else, and the handler enforces that rather than trusting this.
     */
    patient_id: z.string().min(1).max(128).optional(),
});
export const rescheduleAppointmentSchema = z.object({
    /** The new slot on the same specialist. */
    starts_at: z.string().datetime(),
    reason: z.string().trim().max(500).optional(),
});
export const cancelAppointmentSchema = z.object({
    reason: z.string().trim().max(500).optional(),
});
export const acceptAppointmentSchema = z.object({});
/** Filters for listing appointments. Meaning depends on the caller's role. */
export const listAppointmentsQuerySchema = z.object({
    status: appointmentStatusSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export const listCliniciansQuerySchema = z.object({
    specialty: specialtySchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export const availabilityQuerySchema = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    /** Include slots already taken. Only meaningful to the specialist or a coordinator. */
    include_booked: z.coerce.boolean().default(false),
});
/** The coordinator work queue. Defaults to the states that need attention. */
export const adminQueueQuerySchema = z.object({
    status: appointmentStatusSchema.default("requested"),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=booking.js.map